<section class="print-cover" aria-hidden="true">
  <!-- Deux tirages du même logo : la feuille de styles montre l'un ou l'autre
       selon le thème de l'enveloppe. Les images vivent dans les ressources du
       rapport d'origine, recopiées sous `assets/images/report/` — la maquette
       autonome a quitté le bundle. -->
  <span class="brand-logo brand-logo--cover"><img class="brand-logo__img brand-logo__img--ink" src="assets/images/report/logo-skill2era-dark.png" alt="Skill2era" width="447" height="178"><img class="brand-logo__img brand-logo__img--paper" src="assets/images/report/logo-skill2era.png" alt="" aria-hidden="true" width="447" height="178"></span>
  <p class="print-cover__title">{{ 'app.title' | reportT }}</p>
  <span class="print-cover__rule"></span>
  <p class="print-cover__student">{{ view().header.studentName }}</p>

  <!-- Le parcours tient lieu de classe : une seule fente, et pas de séparateur
       — il n'y a rien à séparer. -->
  @if (view().header.learningPathTitle; as path) {
    <p class="print-cover__class"><span>{{ path }}</span></p>
  }

  <dl class="print-cover__meta">
    <div class="print-cover__meta-item">
      <dt class="print-cover__label">{{ 'header.subject' | reportT }}</dt>
      <!-- Libellé déjà résolu par le modèle — nom de matière venu de l'API ou
           mention « toutes les matières ». Le repasser au moteur i18n le
           traiterait comme une clé. -->
      <dd class="print-cover__value-wrap"><span class="print-cover__value">{{ view().header.subjectLabel }}</span></dd>
    </div>
    @if (view().header.testTitle; as test) {
      <div class="print-cover__meta-item">
        <dt class="print-cover__label">{{ 'header.test' | reportT }}</dt>
        <dd class="print-cover__value-wrap"><span class="print-cover__value">{{ test }}</span></dd>
      </div>
    }
    @if (view().header.completedAt; as completedAt) {
      <div class="print-cover__meta-item">
        <dt class="print-cover__label">{{ 'header.date' | reportT }}</dt>
        <dd class="print-cover__value-wrap"><span class="print-cover__value">{{ completedAt | reportFmt: 'date' }}</span></dd>
      </div>
    }
    @if (duration(); as d) {
      <div class="print-cover__meta-item">
        <dt class="print-cover__label">{{ (view().header.durationIsTotal ? 'header.totalDuration' : 'header.duration') | reportT }}</dt>
        <dd class="print-cover__value-wrap"><span class="print-cover__value">{{ d.key | reportT: d.vars }}</span></dd>
      </div>
    }
  </dl>
</section>
